// 导入 types.js 文件
import types from "../types";

const state = {
	menulist: {}
}

const mutations = {
	// 此处的事件为上方 actions 中的 commit(types.TPEOPLE)
	[types.MENULIST](state, data) {
		console.log("调用",data);
		if (data) {
			state.menulist = data;
		} else {
			state.menulist = {};
		}

	}
}

const actions = {
	MENULIST({
		commit
	}) {
		commit(types.MENULIST)
	}
}

// 最后统一导出
export default {
	state,
	actions,
	mutations
}